var React = require('react');

function InlineSvg (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.91602 8C1.91602 7.17157 2.58759 6.5 3.41602 6.5H3.91602V4.5C3.91602 2.29086 5.70688 0.5 7.91602 0.5C10.1252 0.5 11.916 2.29086 11.916 4.5V6.5H12.416C13.2444 6.5 13.916 7.17157 13.916 8V14C13.916 14.8284 13.2444 15.5 12.416 15.5H3.41602C2.58759 15.5 1.91602 14.8284 1.91602 14V11V8ZM7.91602 1.76C5.99902 1.76 5.1662 3.39543 5.1662 4.5V6.49726H10.66V4.5C10.66 3.39543 9.83301 1.76 7.91602 1.76ZM12.6564 14.2422V11V7.76172H7.91758H3.17871V11V14.2422H7.91758H12.6564Z","fill":"#1E242E"}));
}

InlineSvg.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = InlineSvg;

InlineSvg.default = InlineSvg;
